export default "__VITE_ASSET__CJcaVjCH__"